module.exports = __webpack_public_path__ + "static/img/strategy-left.d157588a.png";